import React, {
    useEffect,useState
} from "react";

import {
    Box,
    Flex,
    Badge,
    Text,
} from "@chakra-ui/react";
import StatusBadge, {
    getStatusVariant,
} from "components/Badges/StatusBadge";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

import { useDispatch, useSelector } from "react-redux";
import {
    Eye,
    EllipsisVertical,
} from "lucide-react";

import ThreeDotMenu from "components/Menus/ThreeDotMenu";

import ReviewCommissionDrawer from "./components/ReviewCommissionDrawer";
import ReusableTable from "components/Tables/ReusableTable";

import {
    fetchPendingCommissionsAction,
} from "../../../state/actions/pendingCommissionActions";
import {
    createDriverPartnerPayoutAction,
} from "state/actions/driverPartnerPayoutActions";
import { useCustomNotification } from "components/Toasts/OpenNotification";

import { formatDate } from "utils/dateFormatter";

const CommissionPayoutManagement = () => {
    const dispatch =
        useDispatch();
    const notify =
    useCustomNotification();

    const {
        commissions,
        pagination,
        loading,
    } = useSelector(
        (state) =>
            state.pendingCommissions
    );

    useEffect(() => {
        dispatch(
            fetchPendingCommissionsAction()
        );
    }, [dispatch]);

    const [
    selectedCommission,
    setSelectedCommission,
] = useState(null);

const [
    isReviewOpen,
    setReviewOpen,
] = useState(false);

const openReviewDrawer = (
    commission
) => {
    setSelectedCommission(
        commission
    );
    setReviewOpen(true);
};
const handleCreatePayout = async (
    payload
) => {
    const result =
        await dispatch(
            createDriverPartnerPayoutAction(
                payload
            )
        );

    if (result.success) {
        notify({
            type: "success",
            message:
                "Payout Created",
            description:
                result.message ||
                "Driver partner payout created successfully.",
        });

        dispatch(
            fetchPendingCommissionsAction()
        );

        setReviewOpen(false);
    } else {
        notify({
            type: "error",
            message:
                "Payout Failed",
            description:
                result.error,
        });
    }
};
const generateMenuItems = (
    row
) => [
    {
        icon: (
            <Eye size={16} />
        ),
        text: "Review",
        onClick: () =>
            openReviewDrawer(
                row.original
            ),
    },
];
    const columnsData = [
        {
            Header:
                "Driver Partner",
            accessor:
                "partner_name",
        },
        {
            Header:
                "Driver",
            accessor:
                "driver_name",
        },
        {
            Header:
                "Milestone",
            accessor:
                "milestone_type",
        },
        {
            Header:
                "Commission",
            accessor:
                "commission_amount",
            Cell: ({
                value,
            }) => (
                <Text
                    fontWeight="700"
                    color="#071D54"
                >
                    P{value}
                </Text>
            ),
        },
        {
            Header:
                "Achieved",
            accessor:
                "achieved_at",
            Cell: ({
                value,
            }) =>
                value
                    ? formatDate(
                          value
                      )
                    : "-",
        },
         {
    Header: "Status",
    accessor: "commission_status",
    Cell: ({ value }) => (
        <StatusBadge
            label={value}
            variant={getStatusVariant(value)}
        />
    ),
},
        {
    Header: "Actions",
    accessor: "actions",
    Cell: ({ row }) => (
        <ThreeDotMenu
            icon={
                <EllipsisVertical
                    size={18}
                />
            }
            items={generateMenuItems(
                row
            )}
        />
    ),
},
    ];

    return (
        <Box>
            <Flex
                justify="space-between"
                align="center"
                mb={4}
                pt={{
                    base: "120px",
                    md: "25px",
                }}
            >
                {loading ? (
                    <Skeleton
                        width="220px"
                    />
                ) : (
                    <Text
                        fontWeight="700"
                        fontSize="lg"
                    >
                        Pending
                        Commissions :
                            {pagination.total}
                        
                        
                    </Text>
                )}
            </Flex>

            <ReusableTable
                columnsData={
                    columnsData
                }
                tableData={
                    commissions
                }
                isLoading={
                    loading
                }
            />
            <ReviewCommissionDrawer
    isOpen={isReviewOpen}
    onClose={() =>
        setReviewOpen(false)
    }
    commission={
        selectedCommission
    }
    onSubmit={
        handleCreatePayout
    }
/>
        </Box>
    );
};

export default CommissionPayoutManagement;